import { connectedStore } from '../../store';
import setGlobalHTML from '../actions/set-global-html';
import loadGlobals from './load-globals';
import getNonLoadedGlobals from './get-non-loaded-globals';

const loadGlobalsFromHTML = (html, locale) => {
  const globalsToFetch = getNonLoadedGlobals(html);
  const store = connectedStore.get();

  return loadGlobals(
    globalsToFetch,
    (global, data) => {
      store.dispatch(setGlobalHTML(global.id, data));

      return loadGlobalsFromHTML(data, locale);
    },
    locale
  );
};

export default loadGlobalsFromHTML;
